import { keepPreviousData, useQuery } from "@tanstack/react-query";

import Sentry from "@similarweb/sentry-logger";

import { useToasts } from "app/common/hooks";
import { useTranslation } from "pro-features/components/WithTranslation";
import { DefaultFetchService } from "app/services/fetchService";

export interface IActivationData {
    canEdit: boolean;
    id: string;
    name: string;
    trafficSource: "GA" | "SW";
}

const fetchService = DefaultFetchService.getInstance();

export const useUserdataActivationQuery = (activationId?: string) => {
    const translate = useTranslation();
    const { showErrorToast } = useToasts();

    return useQuery<IActivationData>({
        enabled: !!activationId,
        queryKey: ["userdata", "activation", activationId],
        // @ts-ignore catch block intentionally swallows error — returns undefined to keep query non-failed
        queryFn: async () => {
            try {
                return await fetchService.get(`api/userdata/activation/${activationId}`);
            } catch (error) {
                Sentry.errorTracker({
                    message: "Error in useUserdataActivationQuery hook",
                    e: error,
                    level: "error",
                    params: {
                        extra: { activationId },
                    },
                });
                showErrorToast(translate("common.api.error", { error: (error as Error)?.message }));
            }
        },
        placeholderData: keepPreviousData,
        staleTime: 5 * 60 * 1000,
    });
};
